import React from "react";
import variables from "Assets/style/variablesExport.module.scss";
import CapacityBar from "./CapacityBar/CapacityBar";

type PackageUsageBarProps = {
  capacity: number;
  used: number;
};

const PackageUsageBar = ({
  capacity,
  used,
}: PackageUsageBarProps): React.JSX.Element => {
  const usages = [
    {
      name: "Packages",
      used: used,
      color: variables.portal_usage_fill_color,
    },
  ];

  return (
    <CapacityBar totalCapacity={capacity} usages={usages} showLegend={false} />
  );
};

export default PackageUsageBar;
